import { shallowEqualObjects } from 'shallow-equal';

import type { RequestParams, HttpBody, XhrBody } from './types';

function areParamsEquals(paramA?: object, paramB?: object) {
  if (paramA && paramB) {
    return shallowEqualObjects(paramA, paramB);
  }
  return !!paramA === !!paramB;
}

function areBodyEquals(bodyA?: HttpBody, bodyB?: HttpBody) {
  if (typeof bodyA === 'object' && typeof bodyB === 'object') {
    return shallowEqualObjects(bodyA, bodyB);
  }
  return bodyA === bodyB;
}

function areRequestParamsEquals(paramsA: RequestParams, paramsB: RequestParams): boolean {
  if (paramsA === paramsB) {
    return true;
  }
  return (
    paramsA.url === paramsB.url &&
    paramsA.method === paramsB.method &&
    areParamsEquals(paramsA.query, paramsB.query) &&
    areBodyEquals(paramsA.body, paramsB.body) &&
    areParamsEquals(paramsA.headers, paramsB.headers)
  );
}

function formatBody(body?: HttpBody): XhrBody {
  if (body && body.toString() === '[object Object]') {
    // handle case { [key: string]: any } which is not supported by xhr.send
    return JSON.stringify(body);
  }
  return body as XhrBody;
}

function setHeaders(headers: { [key: string]: string } | undefined, xhr: XMLHttpRequest) {
  if (headers) {
    Object.keys(headers).forEach(key => xhr.setRequestHeader(key, headers[key]));
  }
}

function isRequestOk({ status }: XMLHttpRequest) {
  return status >= 200 && status <= 299;
}

function getResponseHeaders(xhr: XMLHttpRequest): { [key: string]: string } {
  const headers = xhr.getAllResponseHeaders();
  const lines = headers.trim().split(/[\r\n]+/);

  const headerMap: { [key: string]: string } = {};
  lines.forEach(line => {
    const parts = line.split(':').map(value => value.trim());
    const key = parts.shift();
    const value = parts.join(': ');
    if (key) {
      headerMap[key] = value;
    }
  });

  return headerMap;
}

export { areRequestParamsEquals, formatBody, setHeaders, isRequestOk, getResponseHeaders };
